import React from 'react'
import {
  LINK_KEY,
  OFFER_TERMS_TEAL_VARIABLE_NAME,
  UrgencyEntries,
  useUrgency,
} from '@mc/feature-variables'
import { Trans, withI18nContext } from '@mc/i18n'
import { PROMO_UTILS_I18N_NAMESPACE } from '../../constants'
import { i18nInstance } from '../../i18n'
import { usePromotion } from '../../usePromotion'

const URGENCY_CONFIG = {
  link: {
    variableName: OFFER_TERMS_TEAL_VARIABLE_NAME,
    variableKey: LINK_KEY,
  },
} as UrgencyEntries

export const PromoTermsLinkComp = ({
  children,
  i18nKey,
}: {
  children?: React.ReactNode
  i18nKey?: 'offerTerms.promotionPage.hero' | 'offerTerms.promoExplainerModal'
}) => {
  const { isPromotionOn, variables } = usePromotion()
  const urgencies = useUrgency({
    entries: URGENCY_CONFIG,
    variables,
  })

  const termsLink = isPromotionOn ? urgencies.link : ''

  const link = (
    <a
      className='mc-text--link'
      href={termsLink as string}
      target='_blank'
      rel='noopener noreferrer'
    >
      {children}
    </a>
  )

  return i18nKey ? (
    <Trans i18nKey={i18nKey} ns={PROMO_UTILS_I18N_NAMESPACE}>
      {link}
    </Trans>
  ) : (
    link
  )
}

export const PromoTermsLink = withI18nContext(i18nInstance)(PromoTermsLinkComp)
